import WebSocket from 'isomorphic-ws'
import config from '@/config'

let GATEWAY_LOCATION = config.GATEWAY_LOCATION

export function connectSocketApi () {
  return new WebSocket(
    (`${GATEWAY_LOCATION}/api/v1/session/chat`).replace('http', 'ws')
  )
}

// dummy commit 1
